module.exports = __webpack_public_path__ + "img/galaxy-s20-fe_banner.d6a2828.jpg";